module.exports = __webpack_public_path__ + "img/logo.6e9dbe65.png";